(function($){
	/**************************************************************
		HEADER - HAMBURGER
	**************************************************************/

	var forEach=function(t,o,r){if("[object Object]"===Object.prototype.toString.call(t))for(var c in t)Object.prototype.hasOwnProperty.call(t,c)&&o.call(r,t[c],c,t);else for(var e=0,l=t.length;l>e;e++)o.call(r,t[e],e,t)};

	var hamburgers = document.querySelectorAll(".hamburger");
	if (hamburgers.length > 0) {
		forEach(hamburgers, function(hamburger) {
			hamburger.addEventListener("click", function() {
				this.classList.toggle("is-active");
				$('.mobile-nav').toggleClass('is-active');
				$('body').toggleClass('open--nav');
			}, false);
		});
	}


	/**************************************************************
		HEADER - SHRINK ON SCROLL
	**************************************************************/

	var root = document.documentElement;
	var headerTopHeight = getComputedStyle(root).getPropertyValue('--elem-header-height-lg-top').trim().slice(0, -2);

	$(window).scroll(function() {
		if ($(this).scrollTop() > headerTopHeight){
			$('.header').addClass("shrink");
			$('body').addClass("header-shrunk");
		} else {
			$('.header').removeClass("shrink");
			$('body').removeClass("header-shrunk");
		}
	});

    // Scroll on click
    $(document).on('click', 'a[href^="#"]', function (event) {
        event.preventDefault();
        $('html, body').animate({
            scrollTop: $($.attr(this, 'href')).offset().top
        }, 1000);
    });


	// Slick Sliders
	$('#slider').slick({
        autoplay: true,
        autoplaySpeed: 5000,
        speed: 700,
		dots: true,
		arrows: true,
        prevArrow:"<button type='button' class='slick-prev'><i class='fas fa-chevron-left'></i></button>",
        nextArrow:"<button type='button' class='slick-next'><i class='fas fa-chevron-right'></i></i></button>",
		infinite: true,
		slidesToShow: 2,
		slidesToScroll: 1,
        responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1
          }
        }
        ]
	});


    // Accordions
    $(function() {
        $('.accordion-answer').hide();
        $('.accordion-question:first').addClass('active').next().slideDown('slow');
        $('.accordion-question').click(function(){
            if($(this).next().is(':hidden')) {
                $('.accordion-question').removeClass('active').next().slideUp('slow');
                $(this).toggleClass('active').next().slideDown('slow');
            } else if($(this).next().is(':visible')) {
                $(this).toggleClass('active').next().slideUp('slow');
            }
        });
    });



	$("#scrollDown").click(function() {
		var cls = $(this).closest("section").next().offset().top;
		$("html, body").animate({scrollTop: cls}, "slow");
	});


    // Initiate aos animations
	AOS.init();


    // Remove empty paragraphs
    $('p:empty:not([role])').remove();


    //scroll down animaton
  $('a[href*=#]').on('click', function(e) {
    e.preventDefault();
    $('html, body').animate({ scrollTop: $($(this).attr('href')).offset().top}, 500, 'linear');
  });




})(jQuery);


